import React from 'react';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/Hero';
import { BrandSection } from './components/BrandSection';
import { ServiceBanner } from './components/ServiceBanner';
import { AboutSection } from './components/AboutSection';
export function App() {
  return <div className="min-h-screen w-full bg-white font-heading text-slate-900" data-id="element-0" data-mp="3f8exzgol9nsm">
      <Header data-id="element-1" data-mp="2rlf6csv3xo2u" />
      <main data-id="element-2" data-mp="2rit2b37fdqpd">
        <Hero data-id="element-3" data-mp="2riklx1c3g39f" />
        <BrandSection data-id="element-4" data-mp="2mm2o6lf6l56l" />
        <section className="w-full bg-slate-50 pb-16" data-id="element-5" data-mp="2mmlvz9b4ad6w">
          <div className="mx-auto w-full max-w-[1360px] px-5 lg:px-10" data-id="element-6" data-mp="2mjzn96chprn3">
            <ServiceBanner className="min-h-[300px]" data-id="element-7" data-mp="31c1hoavsjsfq" />
          </div>
        </section>
        <AboutSection data-id="element-8" data-mp="2wj8g1vvmd07v" />
      </main>
      <Footer data-id="element-9" data-mp="2wi5l9cv6edmo" />
    </div>;
}